module.exports = __webpack_public_path__ + "img/shoot_00021.87c3ad68.png";